import React, { useState } from "react";
import { Col, Container, Row } from "reactstrap";
import Widget from "./Widgets";
import BestSellingProducts from "./BestSellingProducts";
import RecentActivity from "./RecentActivity";
import RecentOrders from "./RecentOrders";
import Revenue from "./Revenue";
import SalesByLocations from "./SalesByLocations";
import Section from "./Section";
import StoreVisits from "./StoreVisits";
import TopSellers from "./TopSellers";
import { getUserRole } from "../../helpers/role_helper";
import { getLoggedinUser } from "../../api";

const DashboardEcommerce = () => {
  document.title = "Dashboard - TopCoinland";

  const [rightColumn, setRightColumn] = useState(true);
  const toggleRightColumn = () => {
    setRightColumn(!rightColumn);
  };

  const userProfile = getLoggedinUser();
  const userRole = getUserRole(userProfile);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col>
              <div className="h-100">
                <Section rightClickBtn={toggleRightColumn} />
                <Row>
                  <Widget />
                </Row>
                <Row>
                  <Col xl={userRole === "seller" ? 12 : 8}>
                    <Revenue />
                  </Col>
                  {userRole !== "seller" && <TopSellers />}
                </Row>
                <Row>
                  <BestSellingProducts />
                  <RecentOrders />
                </Row>
                <Row>                
                 
                </Row>
              </div>
            </Col>
            {/* <RecentActivity rightColumn={rightColumn} hideRightColumn={toggleRightColumn} /> */}
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default DashboardEcommerce;
